import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-one-page',
  templateUrl: './features-one-page.component.html',
  styleUrls: ['./features-one-page.component.scss']
})
export class FeaturesOnePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
